import {Pattern, match} from 'ts-pattern';

import {Nullish} from 'shared/web';

interface ResolveInitialWarrantyDurationParams {
  /** The warranty program currently assigned to the sale vehicle. */
  warrantyProgramId: string | Nullish;
  /** The warranty duration stored on the sale vehicle. */
  warrantyDuration: number | Nullish;
  /** The per-vehicle default warranty duration. */
  defaultWarrantyDuration: number | Nullish;
}

/**
 * Resolves the warranty duration to pre-fill when the edit vehicle form loads.
 *
 * - With a program assigned, the stored duration is kept (program-driven or manually set).
 * - With no program assigned, the per-vehicle default drives the duration, overriding any
 *   stored value.
 */
export function resolveInitialWarrantyDuration(
  params: ResolveInitialWarrantyDurationParams
): number | null {
  return (
    match(params)
      .with({warrantyProgramId: Pattern.string}, ({warrantyDuration}) => warrantyDuration)
      .otherwise(({defaultWarrantyDuration}) => defaultWarrantyDuration) ?? null
  );
}
